<template>
	<div>
		<div class="page-header" v-bind:style="{ 'background-image': 'url(' + image + ')', 'background-size': '100% 100%' }">
			<div class="container">
				<div class="row">
					<div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
						<div class="page-caption">
							<h1 class="page-title">
                            <img alt="Dantaxi" v-bind:src="require('../../../public/img/T_logo.png')" style="height: 100px;margin-top: 60px" />
                            </h1> </div>
					</div>
				</div>
			</div>
		
			<!-- <div class="lang-holder">
                <a href="javascript:void(0);" @click="updateLanguage('en')" style="margin:7px">
                    <img alt="English" v-bind:src="require('../../assets/images/uk.png')" />
                </a>
                <a href="javascript:void(0);" @click="updateLanguage('da')" >
                    <img alt="Denish" v-bind:src="require('../../assets/images/denmark.png')" />
                </a>
            </div> -->
		</div>
		<!-- /.page-header-->
		<!-- news -->
		<div class="card-section">
			<div class="container">
				<div class="card-block bg-white mb30" style="box-shadow:4px 18px 22px aliceblue; background: gainsboro;">
					<div class="row">
						<div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
							<!-- section-title -->
							<div class="section-title mb-0">
								<div id="thankyou-container">
                                    <h5>{{ $t('message.SIGN')}}</h5>
                                    <p>{{ $t('message.YOU_WILL_RECEIVE_COPY')}}</p>
                                </div>
							</div>
							<!-- /.section-title -->
						</div>
					</div>
					
				</div>
				<div class="row"> </div>
			</div>
		</div>
	</div>
</template>
<script>
  export default {
    name: "Thank You",
  };
</script>
<script>
import {FormWizard, TabContent} from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'   
import Vue from 'vue'
import { Datetime } from 'vue-datetime';

export default {
    components: {
      FormWizard,
      TabContent,
	  Datetime
    },

    data(){
        return{
			name:'',
			email:'',
			phone:'',
			cvr:'',
			type:'',
			dr_number:'',
			reg_number:'',
			new_values:[],
			new_value:null,
			own_risks:[],
			own_risk:null,
			injuries:[],
			injury:null,
			areas:[],
			area:null,
			premium:0,
			car_add_ons:[],
			car_add_on_model: [],
			work_add_ons:[],
			work_add_on_model: [],
            address:'',
			zip_code:'',
			city:'',
			date:null,
			insurance : [],
			select_insurance:'',
			police_number:'',
			trucker_id:'',
			form_data:{},
			previous_insurance:'',
			agreement_id: '',
			status:false,
			step2:false,
			step3:false,
            image : require("../../assets/images/dantaxi-header-new.jpg"),
			nem_id_data: [],
			show_nem_id: false,
        }
    },
	computed: {
		
	},
    methods:{
		async send_xml()
		{
	        let loader = this.$loading.show()

			 try {
               let resp = await Vue.prototype.$http.get('/api/step/send-xml/'+this.$route.params.token)
			   loader.hide()
               
            } catch (e) {
				loader.hide()
               this.$store.dispatch('notifications_alert/error', this.$t('message.SOMETHING_WENT_WRONG'))
            }
		},
		async updateLanguage(lang)
        {
            let loader = this.$loading.show()

            try
            {
                await Vue.prototype.$http.get('/api/auth/lang/'+lang)
                localStorage.setItem('lang', lang)
                this.$i18n.locale =  localStorage.getItem('lang')
                loader.hide()
            }
            catch(e)
            {
               loader.hide();
            }
        }
    },
	created()
	{
		this.send_xml()
	}

}
</script>

<style scoped>
body { -webkit-font-smoothing: antialiased; text-rendering: optimizeLegibility; font-family: 'Overpass', sans-serif; letter-spacing: 0px; font-size: 17px; color: #8d8f90; font-weight: 400; line-height: 32px; background-color: #edefef; }
h1, h2, h3, h4, h5, h6 { color: #25292a; margin: 0px 0px 10px 0px; font-family: 'Overpass', sans-serif; font-weight: 700; letter-spacing: -1px; line-height: 1; }
h1 { font-size: 34px; }
h2 { font-size: 28px; line-height: 38px; }
h3 { font-size: 22px; line-height: 32px; }
h4 { font-size: 20px; }
h5 { font-size: 17px; }
h6 { font-size: 12px; }
p { margin: 0 0 20px; line-height: 1.7; }
p:last-child { margin: 0px; }
ul, ol { }
a { text-decoration: none; color: #8d8f90; -webkit-transition: all 0.3s; -moz-transition: all 0.3s; transition: all 0.3s; }
a:focus, a:hover { text-decoration: none; color: #f85759; }

.page-caption { padding-bottom: 174px; }
.page-title { font-size: 46px; line-height: 1; color: #fff; font-weight: 600; text-align: center; }

.card-section { position: relative; bottom: 60px; }
.card-block { padding: 80px; }
.section-title { margin-bottom: 60px; }
</style>
